module.exports = __webpack_public_path__ + "static/media/logo-dark.65e9b511.png";